document.querySelectorAll('.AgenciesListItem').forEach(AgenciesListItem)

function AgenciesListItem(el) {
    const elPhone = el.querySelector('.AgenciesListItem__phone');
    if(elPhone.dataset.phone) {
        elPhone.addEventListener('click', (e) => {
            e.preventDefault();
            const phone = elPhone.dataset.phone;
            elPhone.outerHTML = `<object><a class="${elPhone.className}" target="_blank" href="tel:${phone}">${phone}</a></object>`;
        }, {once: true})
    }
}
